// src/pages/Home.tsx
import React, { useEffect } from "react";

// componets
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import FileUpload from "../components/FileUpload/FileUpload";
// interfaces
// import { ListItemData } from "../interfaces/ListItemData/ListItemData";
import { Container } from "@mui/material";
import Box from "@mui/material/Box";

// redux
import { useAppDispatch } from "../app/hooks";
import { removeEstimation } from "../features/estimationAmountList/estimationAmountListSlice";
import { changeDisplay } from "../features/managementProcess/managementProcessSlice";
import { fetchSystemSettingAsync } from "../features/systemSetting/systemSettingSlice";
import { reset } from "../features/customerInfo/customerInfoSlice";
import { setIsCreatedOrder } from "../features/accountInfo/accountInfoSlice";
import { resetFailedFiles } from "../features/failedFiles/failedFilesSlice";

const Home: React.FC = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(changeDisplay("Home"));
    dispatch(reset());
    dispatch(removeEstimation());
    dispatch(resetFailedFiles());
    dispatch(fetchSystemSettingAsync());
    dispatch(setIsCreatedOrder(false));
  }, []);

  return (
    <div>
      <Header />
      {/* 固定フッターの高さ分を下余白に加え、画面拡大時も注意文の末尾まで表示できるようにする */}
      <Container
        style={{
          marginTop: "12px",
          marginBottom: "calc(var(--footer-height, 64px) + 24px)",
        }}
      >
        <Box
          border={2}
          borderColor="grey.500"
          style={{ borderStyle: "solid", padding: 12 }}
        >
          <FileUpload />
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default Home;
